import React from 'react';

/**
 * SkeletonRow - animated placeholder matching table row shapes
 * variant: 'contractor' | 'customer' | 'permit'
 */
const SkeletonRow = ({ variant = 'contractor', count = 5 }) => {
  const items = Array.from({ length: count }, (_, i) => i);

  if (variant === 'contractor') {
    return (
      <div className="bg-card rounded-xl border border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Role</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Contact</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Rate</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {items?.map((i) => (
                <tr key={i} className="animate-pulse">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-muted flex-shrink-0" />
                      <div>
                        <div className="h-4 bg-muted rounded w-28 mb-1" />
                        <div className="h-3 bg-muted rounded w-20" />
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4"><div className="h-5 bg-muted rounded-full w-24" /></td>
                  <td className="px-6 py-4">
                    <div className="h-3 bg-muted rounded w-32 mb-1" />
                    <div className="h-3 bg-muted rounded w-24" />
                  </td>
                  <td className="px-6 py-4"><div className="h-6 bg-muted rounded-full w-20" /></td>
                  <td className="px-6 py-4"><div className="h-4 bg-muted rounded w-16" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return null;
};

export default SkeletonRow;
